<template>
  <v-container>
    <v-row dense>
      <v-col
        v-for="(item, i) in items"
        :key="i"
        cols="12"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card @click="navigate(item.platformid,item.invoicetype)" :color="item.color" dark>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline" v-text="item.title"></v-card-title>

              <v-card-subtitle v-text="item.descr"></v-card-subtitle>
            </div>

            <v-avatar class="ma-3" size="125" tile>
              <v-img :src="require('@/assets/' + item.src)" contain></v-img>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  methods: {
    navigate(item,intype) {
      this.$router.push({ path: "/sales-tajmeea", query: { ordertype: item, invoicetype: intype } });
    }
  },
  mounted() {
    this.$store.state.title = "Home";
  },
  components: {},
  data: () => ({
    items: [
      {
        color: "#1F7087",
        src: "floryalogo.png",
        title: "Floria",
        invoicetype:"parts",
        descr: "List sales records and create new invoices for Florya platform",
        platformid: "1"
      },
      {
        color: "#952175",
        src: "iraqitlogo.png",
        title: "Iraq IT",
        invoicetype:"parts",
        descr:
          "List sales records and create new invoices for Iraq IT platform",
        platformid: "2"
      },
      {
        color: "#ff5e08",
        src: "tajmeealogo.png",
        title: "Tajmeea",
        invoicetype:"pc",
        descr:
          "List sales records and create new invoices for Tajmeea platform",
        platformid: "3"
      },
      {
        color: "#280d00",
        src: "futuretechlogo.png",
        title: "Future Tech",
        invoicetype:"pc",
        descr:
          "List sales records and create new invoices for Future Tech platform",
        platformid: "4"
      }
    ]
  })
};
</script>
